import { Box, Typography } from '@mui/material'
import StreamingText from '@/components/ChatResponseElements/StreamingText'
import { traceTypographySx } from './agentReplyPreambleTokens'
import styles from './AgentThoughtTraceBlock.module.scss'

/**
 * Single reasoning trace paragraph (Figma left border + bold body).
 * @param {{ children: string, streaming?: boolean, isActive?: boolean }} props
 */
export function AgentThoughtTraceBlock({ children, streaming = false, isActive = false }) {
  const text = String(children ?? '')
  if (!streaming && !text.trim()) return null
  const showActiveCaret = streaming && isActive

  return (
    <Box className={styles.traceBlock} sx={{ width: '100%', boxSizing: 'border-box', pl: 1, pr: 1 }}>
      <Box
        sx={{
          boxSizing: 'border-box',
          borderLeft: '0.5px solid',
          borderLeftColor: 'divider',
          pl: 1,
          pr: 1,
          py: 0,
          width: '100%',
        }}
      >
        {showActiveCaret ? (
          <StreamingText text={text} showCaret sx={traceTypographySx} />
        ) : text.trim() ? (
          <Typography
            component="div"
            sx={{
              ...traceTypographySx,
              animation:
                'chat-stream-block-enter var(--app-motion-duration-chat-block-enter, 320ms) var(--app-motion-ease-out-soft, cubic-bezier(0.22, 1, 0.36, 1)) both',
            }}
          >
            {text}
          </Typography>
        ) : null}
      </Box>
    </Box>
  )
}
